import { Component, OnDestroy, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from "ng2-toastr";
import { Subscription } from 'rxjs/Subscription';
import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None // this allows parent styles to influence children
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';

  spinner: boolean = false;
  subscriptionSpinner: Subscription;
  autoSave: boolean;

  /**
   *
   * @param {SpinnerService} spinnerService
   * @param {TranslateService} translate
   * @param {ToastsManager} toastr
   * @param {ViewContainerRef} vcr
   */
  constructor(
    private spinnerService: SpinnerService,
    public translate: TranslateService,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef
  ) {
    translate.use("es");
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit(): void {
    this.subscriptionSpinner = this.spinnerService.spinner$
      .subscribe(spinner => this.spinner = spinner);
    this.subscriptionSpinner = this.spinnerService.autoSave$
      .subscribe(autoSave => this.autoSave = autoSave);
  }

  ngOnDestroy(): void {
    this.subscriptionSpinner.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts